import Vue from 'vue'
import store from '@/store'

const loading = status => {
  store.commit('app/isLoading', status)
}

Vue.prototype.$loading = loading
